import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.586 2.5a1.5 1.5 0 0 1 1.06.44l2.856 2.855a1.705 1.705 0 0 1 0 2.41l-1.797 1.797a1.705 1.705 0 0 1-2.41 0L1.44 7.146A1.5 1.5 0 0 1 1 6.086V4a1.5 1.5 0 0 1 1.5-1.5zM3.5 4.5h-.005a.5.5 0 1 0 .005 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.146 2.646a.5.5 0 0 1 .707 0l2.297 2.296a2.91 2.91 0 0 1 0 4.115l-.796.796a.5.5 0 0 1-.707-.707l.796-.796a1.91 1.91 0 0 0 0-2.7L7.147 3.352a.5.5 0 0 1 0-.707",
      style: {"fill-opacity":".4"}
    }, null, -1)
  ])))
}
export default { render: render }